import { useState } from "react";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../ui/select";
import { Label } from "../../ui/label";

const DropDownField: React.FC<any> = ({ item, onChange, index, disabled }) => {
  const lable = item?.name == "real" ? "price" : item?.name;
  // Set default value to the last item of the values array
  const [val, setVal] = useState(item?.value ?? item?.options?.[0] ?? "");
  const onValueChange = (val: string) => {
    setVal(val);
    onChange?.(index, val);
  };

  return (
    <div className="flex flex-col gap-1.5">
      <Label className="uppercase text-[10px] font-bold tracking-wider text-muted-foreground">
        {lable}
      </Label>
      <Select value={val} onValueChange={onValueChange} disabled={disabled}>
        <SelectTrigger className="dark:bg-background border-border hover:bg-accent focus:ring-1 focus:ring-ring rounded-lg h-10 w-full px-3 py-2 text-sm shadow-none transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
          <SelectValue placeholder="Select" />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            {item?.options?.map?.((i: string, index: number) => (
              <SelectItem value={i} key={index} className="cursor-pointer">
                {i}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
};
export default DropDownField;
